import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MessageNotificationViewModel } from '@app/pages/constructor/constructor-components/communication-chart/models/message-notification-view.model';
import { MessageNotificationProgress } from '@app/pages/constructor/constructor-components/communication-chart/enum/message-notification-progress.enum';

@Component({
  selector: 'app-communication-panel-card',
  imports: [DatePipe, MatIconButton, NgClass, RouterLink, TranslatePipe],
  templateUrl: './communication-panel-card.component.html',
  styleUrl: './communication-panel-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommunicationPanelCardComponent {
  @Input({ required: true }) notification: MessageNotificationViewModel;
  @Output() deleteNotification = new EventEmitter<string>();
  @Output() notificationViewed = new EventEmitter<string>();

  public readonly messageNotificationProgress = MessageNotificationProgress;

  private hoverTimeout!: ReturnType<typeof setTimeout>;

  constructor(private router: Router) {}

  public onMouseEnter(): void {
    this.hoverTimeout = setTimeout(() => {
      this.notificationViewed.emit(this.notification.id);
      this.notification = {
        ...this.notification,
        progress: MessageNotificationProgress.Read
      };
    }, 1500);
  }

  public onMouseLeave(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }

  public onDelete(): void {
    this.deleteNotification.emit(this.notification.id);
  }

  public routeToChart(notification: MessageNotificationViewModel): void {
    this.router.navigate([notification.link], {
      queryParams: { messageId: notification.messageId }
    });
  }
}
